import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { GlassPanel } from 'liquidglass-react';

interface FpsCounterProps {
  rendererRef: React.MutableRefObject<any>;
}

const FpsCounter: React.FC<FpsCounterProps> = ({ rendererRef }) => {
  const [fps, setFps] = useState<number>(0);

  React.useEffect(() => {
    let rafId: number;
    const tick = () => {
      if (rendererRef.current) {
        try {
          const metrics = rendererRef.current.getTileMetrics();
          if (metrics) {
            setFps(Math.round(metrics.fps));
          }
        } catch {}
      }
      rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [rendererRef]);

  return (
    <GlassPanel
      cornerRadius={12}
      style={{ padding: '6px 14px' }}
    >
      <Typography
        variant="caption"
        sx={{
          color: 'rgba(255, 255, 255, 0.9)',
          fontSize: '0.75rem',
          fontWeight: 500,
          fontFamily: 'monospace',
          whiteSpace: 'nowrap',
        }}
      >
        {fps} FPS
      </Typography>
    </GlassPanel>
  );
};

export default FpsCounter;
